module.exports = __webpack_public_path__ + "static/media/services.98649469.yaml";


//////////////////
// WEBPACK FOOTER
// ./src/data/services.yaml
// module id = 546
// module chunks = 0